import { motion } from "framer-motion";

/** Animated glowing section divider that draws in on scroll. */
export default function SectionDivider() {
  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10" aria-hidden="true">
      <div className="relative h-px">
        <motion.div
          initial={{ scaleX: 0, opacity: 0 }}
          whileInView={{ scaleX: 1, opacity: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="h-px w-full origin-center bg-gradient-to-r from-transparent via-blue-500/50 to-transparent"
        />
        <motion.span
          initial={{ opacity: 0, scale: 0 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-cyan-300 shadow-[0_0_12px_rgba(34,211,238,0.9)]"
        />
      </div>
    </div>
  );
}
